import styled from "styled-components";

const contentSpace = styled.div`
  margin: 0;

  .submit {
    margin:2px 0;
  }
  .enter {
    margin: 10px 0 0 0;
  }
`


export default contentSpace